import { render, staticRenderFns } from "./ClaimList.vue?vue&type=template&id=65c281be&scoped=true&"
import script from "./ClaimList.vue?vue&type=script&lang=js&"
export * from "./ClaimList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/viewclients.css?vue&type=style&index=0&lang=css&"
import style1 from "./ClaimList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ClaimList.vue?vue&type=style&index=2&id=65c281be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c281be",
  null
  
)

export default component.exports